import React from 'react';

// P14 — Job photo gallery. Loads from a data source (gallery_items); renders
// nothing publicly when there are zero REAL photos (section hidden). No stock
// or AI-generated "job" photos. Alt text required per item.
// Ship empty: real photos get added to this array (or a backend collection) later.
export const GALLERY_ITEMS = [];

export const JobGallery = ({ category = null, items = GALLERY_ITEMS }) => {
  const real = (items || []).filter((i) => i && i.src && (!category || i.category === category));
  if (real.length === 0) return null; // hidden until real photos exist

  return (
    <section data-testid="job-gallery" className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-heading font-bold text-3xl text-[#1E3A5F] mb-8 text-center">
          Recent work in Calgary
        </h2>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {real.map((item, i) => (
            <figure key={i} className="rounded-xl overflow-hidden border border-gray-200 bg-gray-50">
              <img
                src={item.src}
                alt={item.alt || item.caption || 'Flow Forge Mechanical job in Calgary'}
                loading="lazy"
                width={item.width || 800}
                height={item.height || 600}
                className="w-full h-56 object-cover"
              />
              {item.caption && (
                <figcaption className="px-4 py-3 text-sm text-gray-600">{item.caption}</figcaption>
              )}
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default JobGallery;
